import { namespace } from 'vuex-class';
import type { ThemeState } from './theme.types';

export const Theme = namespace('theme');

export function getDefaultState(): ThemeState {
  return {
    theme: null,
  };
}
